<template>
    <div>
      <b-modal centered id="modal-1" title="Gerar código imagem" @hide="resetModal">
        <label for="">Escolha Provedor:</label>
        <b-form-select placeholder="Escolha um provedor" v-model="selectedProviderId" :options="providerOptions" @change="findProvider"></b-form-select>
        <br>
        <label for="">Escolha o arquivo:</label>
        <b-form-file @change="handleFileUpload" placeholder="Escolha um arquivo..." drop-placeholder="Solte o arquivo aqui..."></b-form-file>
        <b-button class="mt-3 btn-success btn-sm" @click="onGetIdImage">Gerar Código Imagem</b-button>
      </b-modal>
    </div>
  </template>

<script>
import AtendimentoRepository from '@/shared/http/repositories/atendimento/atendimento'
import NumRepository from '@/shared/http/repositories/access/cadastroNum'

export default {
  data () {
    return {
      fileData: null,
      providers: [],
      selectedProviderId: null,
      selectedProvider: null
    }
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  async mounted () {
    await this.onGetProviders()
  },
  methods: {
    handleFileUpload (event) {
      const file = event.target.files[0]
      if (file) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.fileData = {
            name: file.name,
            type: file.type,
            base64: e.target.result.split(',')[1]
          }
        }
        reader.readAsDataURL(file)
      }
    },
    closeModal () {
      this.$bvModal.hide('modal-1')
    },
    resetModal () {
      this.fileData = null
    },
    async onGetProviders () {
      const filter = {
        active: 1
      }
      const data = await NumRepository.getEnvAll(filter)
      const response = data.data.content
      this.providers = response
    },
    async onGetIdImage () {
      const req = {
        identifierProvider: this.selectedProvider.number,
        base64: this.fileData.base64,
        filename: this.fileData.name
      }
      const response = await AtendimentoRepository.GetImageId(req)
      const data = response.data.idImage
      this.$emit('idImage', data)
      this.closeModal()
    },
    findProvider () {
      this.selectedProvider = this.providers.find(provider => provider.id === this.selectedProviderId)
    }
  },
  computed: {
    providerOptions () {
      return this.providers.map(provider => ({ value: provider.id, text: provider.name }))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/hsm/components/modal/ModalImage.vue